import { GetUserCommand } from "@aws-sdk/client-cognito-identity-provider";
import { cognitoClient } from "./AuthService"
import axiosInstance from './ApiService';

export const fetchUsers = async (username, nextPageToken = undefined, pageSize = 10) => {
  try {
    const paramsObj = { nextPageToken, pageSize };

    // Create a new object excluding keys with undefined or null values
    const filteredParams = Object.fromEntries(
      Object.entries(paramsObj).filter(([key, value]) => value !== undefined && value !== null)
    );

    const params = new URLSearchParams(filteredParams);
    if (username) params.append('username', username);
    const url = `/users?${params.toString()}`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching users', error);
    throw error;
  }
};

export const fetchUserDetails = async (token) => {
  const accessToken = localStorage.getItem('AccessToken');
  const params = {
    AccessToken: accessToken
  };
  try {
    if (process.env.REACT_APP_USE_MOCK_SERVER === 'true') {
      console.log('Using MOCK to fetch user data')
      const response = await axiosInstance.get('/users/userdetails', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } else {
      const command = new GetUserCommand(params);
      const UserResult = await cognitoClient.send(command);
      if (UserResult) {
        return UserResult;
      }
    }
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
};
